import { pick } from 'Helpers/Affordances';
import fr from 'facet-rest';
import React from 'react';
import PropTypes from 'prop-types';
import useSimpleHousehold from 'Hooks/useSimpleHousehold';
import HouseholdSectionServiceContainer from './HouseholdSectionService/HouseholdSectionServiceContainer';
import HouseholdSectionServiceLegacy from './HouseholdSectionServiceLegacy/HouseholdSectionServiceLegacy';


const HouseholdSectionServicePicker = ({ resource }) => {
  const {
    householdResource,
    household,
    getHousehold,
    updateHousehold,
  } = useSimpleHousehold();
  return pick(resource, {
    [fr.relationships.householdSectionService.name]: (<HouseholdSectionServiceContainer relationshipLink={resource?.relationship(fr.relationships.householdSectionService.name)?.link('related')} />),
  }, (
    <HouseholdSectionServiceLegacy
      leadPlannerId={householdResource.attributes.leadPlannerId}
      csmId={householdResource.attributes.csManagerId}
      serviceLevelId={householdResource.attributes.serviceLevelId}
      getHousehold={getHousehold}
      updateHousehold={updateHousehold}
      householdResource={householdResource}
      household={household}
    />
  ));
};

HouseholdSectionServicePicker.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};
HouseholdSectionServicePicker.defaultProps = {};

export default HouseholdSectionServicePicker;
